<template>
  <div>
    <h4>Can't find an artist?</h4>
    <p>
      Tap to copy this link,<br/>
      share it with them on Instagram.
    </p>
    <b-button
      v-if="!this.clicked"
      variant="coal-primary-yellow"
      :class="className"
      @click="copy"
    >
      <span>wearecoal.com</span>
      <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#282828" fill-rule="evenodd" d="M17.165 2.317a4.504 4.504 0 0 1 0 6.364l-2.829 2.828a4.486 4.486 0 0 1-3.182 1.316 4.481 4.481 0 0 1-3.18-1.316l-.708-.707.707-.707.707.707a3.5 3.5 0 0 0 4.95 0l2.828-2.829a3.505 3.505 0 0 0 0-4.95 3.505 3.505 0 0 0-4.95 0L8.68 5.854l-.707-.707 2.828-2.83a4.503 4.503 0 0 1 6.364 0zM7.973 16.459l2.828-2.829.707.707-2.828 2.83a4.487 4.487 0 0 1-3.182 1.315 4.487 4.487 0 0 1-3.182-1.316 4.504 4.504 0 0 1 0-6.364l2.828-2.829a4.505 4.505 0 0 1 6.364 0l.707.707-.707.707-.707-.707a3.505 3.505 0 0 0-4.95 0l-2.828 2.83a3.505 3.505 0 0 0 0 4.95 3.504 3.504 0 0 0 4.95 0z"/></svg>
    </b-button>

    <b-button v-else variant="coal-primary-yellow keep-active">
      <span>copied</span>
      <svg svg-inline="" class="icon check" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9"><path fill="none" stroke="#F0F0F0" d="M1 4l3 5 6-9"/></svg>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'ShareWithArtist',
  data() {
    return {
      label: 'wearecoal.com',
      clicked: false,
    };
  },
  computed: {
    className() {
      return this.clicked ? 'keep-active' : '';
    },
  },
  methods: {
    copy() {
      const el = document.createElement('textarea');
      el.value = 'http://j.mp/ShareCoal';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.clicked = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  p {
    color: #787878;
    line-height: 19.2px;
  }

  button {
    width: 190px;
    height: 35px;
    display: inline-flex;

    svg {
      margin-left: auto;

      &.check {
        margin-top:6px;

        path {
          fill: none !important;
        }
      }
    }
  }

  .desktop button {
    width: 205px;
  }
</style>
